import { createPage } from "@/shared/bootstrap/createPage"

import OfficialPage from "./OfficialPage"
import officialMessages from "./i18n/official-data.json"

createPage({
  name: "official",
  titleKey: "official_meta_title",
  // 官网是唯一开放三语（简中 / 英语 / 柬埔寨语）的页面
  locales: ["zh_CN", "en_US", "km_KH"],
  // 面向柬埔寨本地用户：默认柬语，且不按系统 / 浏览器语言自动切换
  // （当地设备的系统语言分布很杂，跟随系统会把官网带偏）。
  // 用户仍可用右上角语言选择器或 ?lang=zh_CN|en_US|km_KH 显式切换，选择会记忆到 localStorage。
  defaultLocale: "km_KH",
  detectSystemLang: false,
  messages: officialMessages,
  render: () => <OfficialPage />,
})
